import { Modal } from "antd";
import { Flex } from "@chakra-ui/layout";
import FormFiltros from "./FormFiltros";
import FooterModalFiltros from "./FooterModalFiltros";
import Toolbar from "components/Toolbar";
import { DespesaQuery } from "features/relatorios/typings";
import { useEffect } from "react";

interface ModalFiltrosProps {
  isOpenModal: boolean;
  onClose: () => any;
  filtro: DespesaQuery;
  onChangeFiltro: (v?: Partial<DespesaQuery>) => void;
  onChangeLocalFiltro: (v: Partial<DespesaQuery>) => void;
  numeroFiltroSelecionados: number;
  localFiltro: DespesaQuery;
}

function ModalFiltros({
  isOpenModal,
  onClose,
  filtro,
  onChangeLocalFiltro,
  onChangeFiltro,
  localFiltro,
  numeroFiltroSelecionados,
}: ModalFiltrosProps) {
  useEffect(() => {
    if (isOpenModal) {
      onChangeLocalFiltro(filtro);
    }
  }, [filtro, isOpenModal, onChangeLocalFiltro]);

  return (
    <Modal
      centered
      visible={isOpenModal}
      footer={
        <FooterModalFiltros
          value={numeroFiltroSelecionados}
          onCancel={onClose}
          onClear={() => {
            onChangeFiltro(undefined);
            onClose();
          }}
          onSubmit={() => {
            onChangeFiltro(localFiltro);
            onClose();
          }}
        />
      }
      onCancel={onClose}
      destroyOnClose
      width="700px"
      className="antd-custom-header"
      title={<Toolbar title="Filtros" onClose={onClose} border="0px" />}
      closable={false}
    >
      <Flex flexDirection="column">
        <FormFiltros
          filtro={localFiltro}
          onChangeFiltro={onChangeLocalFiltro}
        />
      </Flex>
    </Modal>
  );
}

export default ModalFiltros;
